<template>
    <div>
        <v-select
          label="name"
          :filterable="false"
          :options="options"
          v-model="selected"
          @search="onSearch"
          @input="setSelected"
        >
            <template slot="no-options">
              {{ placeholderText }}
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.name_NL }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.name_NL }}
              </div>
            </template>
        </v-select>
    </div>
</template>

<script>
import Station from '@/services/hatsApi/Station'
import _ from 'lodash'

export default {
  data () {
    return {
      placeholderText: this.placeholder,
      options: [],
      selected: this.selectedValue
    }
  },
  props: {
    placeholder: {
      default: 'Search station',
      type: String,
      required: false
    },
    selectedValue: {
      default: null,
      type: Object,
      required: false
    }
  },
  methods: {
    setSelected (value) {
      this.$emit('update:selectedValue', value)
    },
    onSearch (search, loading) {
      loading(true)
      this.search(loading, search, this)
    },
    search: _.debounce((loading, search, vm) => {
      let filters = [
        {
          property: 'name',
          value: escape(search)
        }
      ]
      Station.search(filters).then((response) => {
        vm.options = response.data.data
        loading(false)
      })
    }, 500)
  }
}
</script>

<style scoped>
  div >>> .vs__dropdown-toggle {
    border: 0;
    padding: 0;
  }
  div >>> .vs__open-indicator {
    display: none;
  }
  div >>> .vs__clear {
    margin-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/search/Station.vue